import { TmAuthError } from '@/core/error/transport/auth/TmAuthError'

export class TmAuthNeedEnterCaptchaError extends TmAuthError {}
